import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import PasswordField from "@/components/PasswordField";
import { API } from "@/context/AuthContext";
import { AccessMessage } from "@/pages/VerifyEmail";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [complete, setComplete] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const token = params.get("token");

  if (complete) return <AccessMessage title="Password updated" message="Your password has been reset. Please sign in with your new password." />;
  const submit = async (event) => {
    event.preventDefault();
    if (!token) return setError("This reset link is incomplete.");
    if (password !== confirmation) return setError("Passwords do not match.");
    setSubmitting(true); setError("");
    try {
      await axios.post(`${API}/auth/password/reset/confirm`, { token, password });
      setComplete(true);
    } catch (requestError) {
      setError(requestError.response?.data?.detail || "We could not reset your password.");
    } finally { setSubmitting(false); }
  };
  return <div className="min-h-screen bg-bone"><main className="max-w-xl mx-auto px-6 py-28">
    <form className="editorial-card p-10" onSubmit={submit}><div className="overline mb-4">§ ACCOUNT SECURITY</div><h1 className="font-serif text-5xl">Choose a new password.</h1>
      <PasswordField label="New password" className="mt-8" value={password} onChange={(event) => setPassword(event.target.value)} minLength={12} autoComplete="new-password" />
      <PasswordField label="Confirm password" className="mt-5" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} minLength={12} autoComplete="new-password" />
      <p className="mt-2 text-xs text-[--muted-foreground]">Use 12+ characters with uppercase, lowercase, and a number.</p>{error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <button className="btn-primary mt-7 w-full justify-center" disabled={submitting}>{submitting ? "Updating…" : "Reset password"}</button>
    </form>
  </main></div>;
}
